import { BaseServiceProvider } from './BaseServiceProvider'

const BASE_URL = import.meta.env.VITE_INTRANET_SERVICE_URL

export interface SalesPadOrg {
  childOrgName: string
  id: number
  status: number
  childOrgId: number
  isCSC: boolean
}

export interface SalesPadOrgResponse {
  Data: SalesPadOrg[]
  status: 'success' | 'error'
}

class SalesPadServiceProvider extends BaseServiceProvider {
  constructor() {
    super(BASE_URL, 'salespad', '1.0', '')
  }

  fetchSalesPadOrgs = async (
    userId: string,
    orgId: string
  ): Promise<SalesPadOrg[]> => {
    const { data } = await this.get<SalesPadOrgResponse>('acctOrgs', {
      params: { userId, orgId, start: 0, limit: -1 },
    })

    return data?.Data
  }
}

export default new SalesPadServiceProvider()
